import type { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { ExpansionPanel } from '@finn-no/troika-react-expansion-panel';

interface Props {
    title: string;
    noBorder?: boolean;
}

export const FilterGroup = ({ title, children, noBorder = false }: PropsWithChildren<Props>) => {
    const testId = `filter-${title.substring(0, 1).toLowerCase()}${title.substring(1).replace(' ', '-')}`;

    return (
        <ExpansionPanel
            className={classNames('custom-expansion-panel u-ma0', { 'no-border': noBorder })}
            title={title}
            expanded
            data-testid={testId}>
            {children}
        </ExpansionPanel>
    );
};
